"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenQueryParam = void 0;
var _react = require("react");
var _constants = require("../constants");
var _utils = require("../utils");
const useOpenQueryParam = () => {
  const [param, setParam] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const queryParam = (0, _utils.getOpenQueryParam)() ?? '';
    if (_constants.OPEN_QUERY_PARAM_VALID_VALUES.includes(queryParam)) {
      setParam(queryParam);
    }
  }, []);
  return param;
};
exports.useOpenQueryParam = useOpenQueryParam;
